import { Fragment } from "react";
import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { NavigateLinks, UIKits } from "../../../Constants/Constants";
import BackgroundColorOpacity from "./BackgroundColorOpacity";
import BorderOpacity from "./BorderOpacity";
import LinkUnderlines from "./LinkUnderlines";
import LinkUtilities from "./LinkUtilities";
import CommonLinks from "./CommonLinks";

const NavigateLinksContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={NavigateLinks} parent={UIKits} />
      <Container fluid>
        <Row>
          <LinkUtilities />
          <LinkUnderlines />
          <BorderOpacity />
          <BackgroundColorOpacity />
          <CommonLinks />
        </Row>
      </Container>
    </Fragment>
  );
};

export default NavigateLinksContainer;
